import List from './list';
import CompleteList from './completeList';
import Info from './info';
import Edit from './edit';

let routes = [];
routes = routes.concat({ path: 'list', exact: true, name: 'basic', component: <List /> });
routes = routes.concat({ path: 'completelist', exact: true, name: 'basic', component: <CompleteList /> });
routes = routes.concat({ path: 'info', exact: true, name: 'basic', component: <Info /> });
routes = routes.concat({ path: 'edit', exact: true, name: 'basic', component: <Edit /> });
routes = routes.concat({ path: 'edit/:id', exact: true, name: 'basic', component: <Edit /> });

export default routes;
